import { render, staticRenderFns } from "./ScreenDesign4.vue?vue&type=template&id=f7ec75f0&scoped=true"
import script from "./ScreenDesign4.vue?vue&type=script&lang=js"
export * from "./ScreenDesign4.vue?vue&type=script&lang=js"
import style0 from "./ScreenDesign4.vue?vue&type=style&index=0&id=f7ec75f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ec75f0",
  null
  
)

export default component.exports